import { CombinedMainCategory } from '~/App/shared/types/MainCategoryTypes';
import {
  MinMaxIntervalKey,
  minMaxIntervalValues as initialMinMaxIntervalValues
} from '~/config/constants';
import { SliderType } from './components/FilterSelector/types';
import { ObjectListDevice } from './components/ObjectListContainer';

export const getMinMaxIntervalValues = (
  mainCategory?: CombinedMainCategory
) => {
  switch (mainCategory) {
    case 'transport_and_machinery':
      return {
        ...initialMinMaxIntervalValues,
        odometerReading: [0, 2500000]
      } as Record<MinMaxIntervalKey, SliderType>;

    default:
      return initialMinMaxIntervalValues;
  }
};

export const getInitialAmountOfSkeletons = (device: ObjectListDevice) => {
  switch (device) {
    case 'mobile':
      return 4;
    case 'tablet':
      return 6;
    case 'desktop':
      return 8;
  }
};

export function getSingleMainCategory(
  mainCategories?: CombinedMainCategory[]
): CombinedMainCategory | undefined {
  if (!mainCategories) return undefined;
  if (mainCategories.length > 1) {
    return 'transport_and_machinery';
  } else return mainCategories[0];
}
